export const ACCOUNT_LOAD_START = 'ACCOUNT_LOAD_START';
export const ACCOUNT_LOAD_SUCCESS = 'ACCOUNT_LOAD_SUCCESS';
export const ACCOUNT_META_LOAD_SUCCESS = 'ACCOUNT_META_LOAD_SUCCESS';
export const ACCOUNT_LOAD_FAILURE = 'ACCOUNT_LOAD_FAILURE';
export const ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_START = 'LOGOUT_START';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const REGISTER_START = 'REGISTER_START';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const REFRESH_START = 'REFRESH_START';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const REFRESH_FAIL = 'REFRESH_FAIL';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';

export const CURRENT_ACCOUNT_EMPLOYER_PROFILES_LOAD_SUCCESS =
  'CURRENT_ACCOUNT_EMPLOYER_PROFILES_LOAD_SUCCESS';
